import * as React from 'react';
const SvgSearch = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.25 12.503a6.25 6.25 0 115.07-2.595l3.887 3.888a1 1 0 01-1.414 1.414l-3.887-3.887a6.222 6.222 0 01-3.656 1.18zm0-2a4.25 4.25 0 100-8.5 4.25 4.25 0 000 8.5z"
            fill="currentColor"
        />
    </svg>
);
export default SvgSearch;
